import { useAppSelector } from '@app/redux/hooks';
import { WrapperSubMenu } from '@app/Layout/Header/Blocks';
import { MyLink } from '@app/components/ui-kit/Link';
import IconRectangle from './rectangle.svg';
import classNames from 'classnames';

import styles from './BuyerSelection.module.scss';

export const BuyerSelection = (): JSX.Element => {
  const { customerLinkHeader } = useAppSelector(state => state.header.data.headerMenu);
  return (
    <div className={classNames(styles.Container)} data-testid="header-btn-buyer">
      <div className={styles.Title}>
        {customerLinkHeader?.title}
        <IconRectangle width={5.66} height={3} />
      </div>
      <WrapperSubMenu className={styles.SubMenu}>
        {customerLinkHeader?.items?.map(x => {
          return (
            <MyLink href={x.url} key={x.title} data-testid={x.url}>
              <div>{x.title}</div>
            </MyLink>
          );
        })}
      </WrapperSubMenu>
    </div>
  );
};
